import * as c3m from "./car/3m.js"
import * as cOracle from "./car/oracle.js"
import * as cAvery from "./car/avery.js"

import * as gLlumar from "./glass/llumar.js"
import * as g3m from "./glass/3m.js"

/* Sample palettes for testing */
//"ORAJET 3951" : cOracle.palette_oracle_3951

const carPaintProps = {
    "Oracle" : {
        "ORACAL 970 Standard" : cOracle.palette_oracle_970_standard,
        "ORACAL 970 Metallic" : cOracle.palette_oracle_970_metallic,
        "ORACAL 970 Mat" : cOracle.palette_oracle_970_matte,
        "ORACAL 970 Metallic Mat" : cOracle.palette_oracle_970_metallic_matte,
    },
    "3M" : {
        "1080 Light Series" : c3m.palette_3m_1080,
        "2080 Pro Series" : c3m.palette_3m_2080,
        "3080 Ultra Series" : c3m.palette_3m_3080 
    },
    "Avery Dennison": {
        "Supreme SW900" : cAvery.palette_avery_SW900
    }
}

function getCarPaintProps ( brand, model, color) {
    return carPaintProps[brand][model][color];
}

function getCarPaintPalette (brand, model) {
    return Object.keys(carPaintProps[brand][model])
}



const glassPaintProps = {
    "LLumar" : {
        "ATC Serisi" : gLlumar.palette_llumar_atc,
        "ATR Serisi" : gLlumar.palette_llumar_atr,
        "CTXI Serisi" : gLlumar.palette_llumar_ctxi,
        "AIR,PP Serisi" : gLlumar.palette_llumar_air_pp,
        "Safety SCL Serisi" :  gLlumar.palette_llumar_safety_scl,
        "IRX Serisi" : gLlumar.palette_llumar_irx,
    },
    "3M" : {
        "Pro Glass 9000" : g3m.palette_3m_9000,
    }
}

function getGlassPaintProps ( brand, model, color) {
    return glassPaintProps[brand][model][color];
}


function getGlassPaintPalette (brand, model) {
    const vanillaArr = Object.keys(glassPaintProps[brand][model])
    const splitSize = 2
    const nested = vanillaArr.reduce((a, c, i) => {
        return i % splitSize === 0 ? a.concat([vanillaArr.slice(i, i + splitSize)]) : a;
      }, []);
    return nested
}

export {carPaintProps, getCarPaintProps, getCarPaintPalette, glassPaintProps, getGlassPaintProps, getGlassPaintPalette}

